/* WEAK THINGS: when a shopper picks a color that doesn't come in the selected size,
   switch to the nearest size that exists so photo, price and Add to cart stay correct. */
(async () => {
  try {
    const m = location.pathname.match(/\/products\/([^/?#]+)/); if (!m) return;
    const p = await (await fetch('/products/' + m[1] + '.js')).json();
    const name = o => (o && o.name) || o;
    const ci = p.options.findIndex(o => /colou?r/i.test(name(o)));
    const si = p.options.findIndex(o => /size/i.test(name(o)));
    if (ci < 0 || si < 0) return;
    const order = p.options[si].values || [];
    const has = (c, s) => p.variants.some(v => v.options[ci] === c && v.options[si] === s);
    document.addEventListener('change', e => {
      const t = e.target;
      if (!t.matches || !t.matches('input[type=radio][data-option-name]') || !/colou?r/i.test(t.dataset.optionName)) return;
      const root = t.closest('variant-picker') || document;
      const sizes = [...root.querySelectorAll('input[type=radio][data-option-name]')].filter(i => /size/i.test(i.dataset.optionName));
      const cur = sizes.find(i => i.checked);
      if (!cur || has(t.value, cur.value)) return;
      const k = order.indexOf(cur.value);
      const ok = sizes.filter(i => has(t.value, i.value)).sort((a, b) =>
        Math.abs(order.indexOf(a.value) - k) - Math.abs(order.indexOf(b.value) - k) || order.indexOf(b.value) - order.indexOf(a.value));
      if (ok[0]) { cur.checked = false; ok[0].checked = true; }
    }, true);
  } catch (err) {}
})();
